import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Layout } from 'antd';
import Dashboard from './pages/Dashboard';
import Sidebar from './components/Sidebar';
import AddExpense from './pages/AddExpense';
import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn';
import Setting from './pages/Settings';
import ExpenseList from './pages/ExpenseList';
import CategoryDetail from './pages/CategoryDetail';
import AddLedger from './pages/AddLedger';
import LedgerList from './pages/LedgerList';
import PersonDetail from './pages/PersonDetail';
import CategoryCards from './components/CategoryCards';
import UpdatePassword from './pages/UpdatePassword';
const { Sider, Content } = Layout;
const App = () => {
  const [collapsed] = useState(true);
  const [activePage, setActivePage] = useState('dashboard');

  const colorBgContainer = '#EEEEEE';
  const footerStyle = {
    position: 'fixed',
    bottom: '0',
    right: '0',
    zIndex: '5',
    backgroundColor: '#2d2a2ac0',
    color: '#ffffff',
    padding: '2px 10px',
    borderRadius: '10px 0 0 0',
    fontSize: '10px',
  };

  const footerLinkStyle = {
    textDecoration: 'none',
    color: '#ffffff',
  };
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider trigger={null} collapsible collapsed={collapsed} style={{ background: '#31363F'}}>
        <div className="demo-logo-vertical" />
        <Sidebar setActivePage={setActivePage} activePage={activePage} /> 
      </Sider>
      <Layout>
        <Content
          style={{
            minHeight: 280,
            background: colorBgContainer,
          }}
        >
          <Routes>
              <Route path='/' element={<Dashboard />} />
              
              <Route path='/addExpense' element={<AddExpense />} />
              <Route path='/expenseList' element={<ExpenseList />} />
              <Route path='/addLedger' element={<AddLedger />} />
              <Route path='/ledger' element={<LedgerList />} />
              <Route path='/settings' element={<Setting />} />

              <Route path='/signIn' element={<SignIn />} />
              <Route path='/signUp' element={<SignUp />} />
              <Route path="/updatePassword" element={<UpdatePassword />} />

              <Route path="/project/:project" element={<CategoryCards />} />
              <Route path="project/:project/category/:category" element={<CategoryDetail />} />
              <Route path="/person/:person" element={<PersonDetail />} />
            </Routes>
        </Content>
      </Layout>
      <div style={footerStyle}>
        <a href="https://rapidmis.com/" style={footerLinkStyle} target="_blank" rel="noopener noreferrer">
          Powered By RapidMIS
        </a>
      </div>
    </Layout>
  );
};
export default App;